var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkChargeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,1C7.7285156,1,1,7.7285156,1,16s6.7285156,15,15,15s15-6.7285156,15-15S24.2714844,1,16,1z M16,29 C8.8320312,29,3,23.1679688,3,16S8.8320312,3,16,3s13,5.8320312,13,13S23.1679688,29,16,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,8h-7c-0.5527344,0-1,0.4472656-1,1v15h2v-6h6c2.7568359,0,5-2.2431641,5-5S20.7568359,8,18,8z M18,16h-6v-6h6 c1.6542969,0,3,1.3457031,3,3S19.6542969,16,18,16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkChargeSmall);
export default __webpack_public_path__ + "static/media/park-charge--small.3650283a4b563a44d89cd4f634b50ee0.svg";
export { ForwardRef as ReactComponent };